import React, { useState, useContext } from 'react';
import { Bar } from 'react-chartjs-2';

import { ThemeContext } from 'styled-components';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { DataChartContainer, DataChartHandlers } from './DataChartStyled';
import { randomizeDataset } from '../../../mockData/chartData';


export interface Props {
  datasetLabel: string
  data:{
    labels: number[] | string[]
    data: number[] | string[]
  };
}

const DataChartWrapper: React.FC<Props> = ({
  ...props
}: Props) => {
  const themeContext = useContext(ThemeContext);
  const primaryColor = themeContext.colors[themeContext.name].primary;

  const [dataFilter, setDataFilter] = useState(7); // dias
  const [dataType, setDataType] = useState('Comentários'); // qual dado a ser exibido no gráfico
  const [dataToShow, setDataToShow] = useState({
    labels: props.data.labels,
    datasets: [
      {
        label: dataType,
        data: props.data.data,
        backgroundColor: primaryColor,
      },
    ],

  });

  const handleChangeDataType = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const dataToShowState = dataToShow;

    dataToShowState.datasets[0].label = e.target.value;

    setDataType(e.target.value);

    setDataToShow({ ...dataToShowState });
    randomizeDataset();
  };

  const hanldeChangeDataFilter = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setDataFilter(parseInt(e.target.value));
  };

  return (
    <DataChartContainer {...props}>
      <DataChartHandlers>
        <FormControl>
          <InputLabel id="chartMetricLabel">Métrica</InputLabel>
          <Select
            labelId="chartMetricLabel"
            id="chartMetric"
            value={dataType}
            onChange={(e) => handleChangeDataType}
          >
            <MenuItem value="Comentários">Comentários</MenuItem>
            <MenuItem value="Aulas Assistidas">Aulas Assistidas</MenuItem>
            <MenuItem value="Reactions Recebidos">Reactions Recebidos</MenuItem>
          </Select>
        </FormControl>
        <FormControl>
          <InputLabel id="chartMetricLabel">Período</InputLabel>
          <Select
            labelId="chartMetricLabel"
            id="chartMetric"
            value={dataFilter}
            onChange={(e) => hanldeChangeDataFilter}
          >
            <MenuItem value={7}>Últimos 7 dias</MenuItem>
            <MenuItem value={15}>Últimos 15 dias</MenuItem>
            <MenuItem value={30}>Últimos 30 dias</MenuItem>
          </Select>
        </FormControl>
      </DataChartHandlers>
      <Bar
        data={dataToShow as any}

        height={10}
        options={
          {
            plugins: {
              legend: {
                position: 'bottom',
                display: false,
              },
            },
            maintainAspectRatio: false,
            scales: {
              x: {
                grid: {
                  display: false,
                },
              },
              y: {
                grid: {
                  display: false,
                },
                ticks: {
                  display: false, // this will remove only the label
                },
              },
            },
          }
        }
      />
    </DataChartContainer>
  );
};

export { DataChartWrapper as DataChart };
